import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  useEffect(() => {
    // Load Iubenda script
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[src="https://cdn.iubenda.com/iubenda.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      {/* Header */}
      <header className="bg-[#4A7C59] py-4 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-white hover:text-white/80 transition-colors">
            <ArrowLeft className="w-6 h-6" />
          </Link>
          <h1 className="text-xl font-bold text-white">Termini e Condizioni</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        {/* Disclaimer Tasto Scudo Emergenza */}
        <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6 mb-6">
          <h2 className="text-lg font-bold text-amber-800 mb-3 flex items-center gap-2">
            ⚠️ Avviso Importante: Tasto Scudo Emergenza
          </h2>
          <div className="space-y-3 text-sm text-amber-900">
            <p>
              Il <strong>"Tasto Scudo Emergenza"</strong> è una funzionalità che consente all'assistente familiare 
              di inviare una <strong>notifica push ai familiari</strong> registrati sulla piattaforma CuraCheck 
              in caso di necessità.
            </p>
            <p className="font-semibold">
              ⛔ Il Tasto Scudo NON è collegato ai servizi di emergenza pubblici (112, 118, Pronto Soccorso 
              o qualsiasi altro servizio di soccorso istituzionale).
            </p>
            <p>
              L'utilizzo di questa funzionalità non sostituisce in alcun modo la chiamata ai numeri di emergenza 
              in caso di pericolo imminente per la vita o la salute. In situazioni di emergenza medica o di sicurezza, 
              è responsabilità dell'utente contattare immediatamente i servizi di emergenza competenti.
            </p>
            <p>
              CuraCheck S.r.l. non si assume alcuna responsabilità per danni diretti o indiretti derivanti 
              dall'utilizzo improprio del Tasto Scudo o dalla mancata attivazione dei servizi di emergenza pubblici 
              quando necessario.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          {/* Iubenda Embed */}
          <a 
            href="https://www.iubenda.com/termini-e-condizioni/64056428" 
            className="iubenda-nostyle iubenda-noiframe iubenda-embed iub-body-embed" 
            title="Termini e Condizioni"
          >
            Termini e Condizioni
          </a>
        </div>

        {/* Back link */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#4A7C59] hover:text-[#3A6345] font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla Home
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 text-center text-sm text-[#64748B]">
        <p>© 2026 CuraCheck - A.M.D. GENERAL HOLDING S.R.L.S.</p>
      </footer>
    </div>
  );
};

export default TermsPage;
